import styled, { keyframes } from 'styled-components';

import colors from '@/design/colors';
import ExpandButton from '@/components/ExpandButton';
import SectionPanel from '../SectionPanel';

export const GroupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ItemRow = styled.div`
  position: relative;
`;

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const CONNECTOR_EASING = 'cubic-bezier(0.55, 0.085, 0.68, 0.53)';

export const SubGroupContent = styled.div<{ expanded: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 24px;

  /* Connector coming out of the SectionPanel and curving down to the first item */
  > :first-child {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: -24px;
      bottom: -8px;
      width: 24px;
      height: calc(50% + 8px);
      border-left: 1px solid ${colors.gray100};
      border-top: 1px solid ${colors.gray100};
      border-top-left-radius: 8px;
      animation: ${({ expanded }) => (expanded ? fadeIn : fadeOut)}
        ${({ expanded }) => (expanded ? '180ms' : '120ms')} ${CONNECTOR_EASING}
        both;
    }
  }

  ${ItemRow} {
    /* Curved hook entering each item at its middle */
    &::before {
      content: '';
      position: absolute;
      left: -24px;
      top: 0;
      width: 24px;
      height: 50%;
      border-left: 1px solid ${colors.gray100};
      border-bottom: 1px solid ${colors.gray100};
      border-bottom-left-radius: 8px;
      animation: ${({ expanded }) => (expanded ? fadeIn : fadeOut)}
        ${({ expanded }) => (expanded ? '180ms' : '120ms')} ${CONNECTOR_EASING}
        both;
    }

    /* Continuous vertical spine spanning the item plus the gap to the next one */
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: -24px;
      top: 0;
      width: 1px;
      height: calc(100% + 8px);
      background-color: ${colors.gray100};
      animation: ${({ expanded }) => (expanded ? fadeIn : fadeOut)}
        ${({ expanded }) => (expanded ? '180ms' : '120ms')} ${CONNECTOR_EASING}
        both;
    }
  }
`;

export const SubgroupSectionPanel = styled(SectionPanel)`
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 58px; /* space for the expand button */
`;

export const SubGroupExpand = styled(ExpandButton)`
  color: ${colors.gray300};
  background-color: transparent;
  border: none;
  border-radius: 0;

  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  margin-right: 16px;
  margin-left: 8px;

  &:hover:not(:disabled) {
    color: ${colors.blackAlpha100};
    background-color: transparent;
  }
`;

export const GroupFooter = styled.div`
  display: flex;
  flex-direction: column;
`;
